<template>
<div>
                    <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel" />

    <scroller ref="helpListScroller" :on-refresh="refresh" :on-infinite="infinite">

            <div style="padding:10px; font-size:14px;">
                {{user.name}}({{user.phone}})<em class="logout" @click="logout">[更换账号]</em>
            </div>
        <van-notice-bar :scrollable="true" >
             以下是您报名成功记录，仅用于信息核对
        </van-notice-bar>
        <div v-if="list&&list.length>0" class="help-list">
            <router-link tag="div" v-for="item in list" :to="{name: 'saiConfirm',query:{'id':item.id}}" :key="item.id"  class="help-item">
                <div class="item-title">{{item.mingcheng}}
                    <!--<van-tag v-if="item.confirm==2" type="danger">待处理</van-tag>-->
                    <!--<van-tag v-else plain type="success">已确认</van-tag>-->
                </div>
                <p class="item-time">{{item.sqname}}</p>
            </router-link>
        </div>
        <div v-else></div>

    </scroller>

</div>
</template>

<style scoped="">
    .help-list{}
    .help-item{position: relative;padding: 10px 10px 10px 15px;background-color: #fff}
    .help-item:after{ content: ''; position: absolute; left: 15px; right: 0; bottom: 0; border-bottom: 1px solid #d9d9d9; transform: scaleY(0.5); }
    .help-item:last-child:after{border:none;}
    .help-item .item-title{color: #333;font-size: 16px;}
    .help-item .item-time{color: #999;font-size: 12px;padding-top: 6px;}

    .logout{font-weight: bold; color: #4a90e2}
</style>
<script>
    import {
            Cell, CellGroup,Tag,NoticeBar
    } from 'vant';
	import LoginDialog from '@/components/LoginDialog.vue';
    export default {
        name: 'saiManage',
        components: {
            [Cell.name]: Cell,
            [Tag.name]: Tag,
            [NoticeBar.name]: NoticeBar,
            LoginDialog
        },
        data:function () {
            return {
                loginShow:false,
                "list":[],
                user:{

                },
                "scrollerParams":{
                    "p":1,
                    "step":12,
                    "totalpage":1
                },
            }
        },
        mounted: function(){
            document.title = "报名记录";
        },
        methods: {
            logout(){
                var that = this;
                if(confirm('您确定要退出登录吗?')){
                    localStorage.removeItem('_token');
                    this.$api.get('/api/index/logout',{},r=>{
                    location.reload();
                    });
                }


            },
            getData:function(callback){
                let self = this;
                let that = this;
                this.$api.get('/api/sai/applylist', self.scrollerParams, r => {
                    self.user = r.data.user;
                    if(self.scrollerParams.p == 1){
                        self.list = r.data.list;
                        if(r.data.list && r.data.list.length && r.data.list.length > 0){
                            self.$refs.helpListScroller.finishInfinite(true);
                        }
                        self.$refs.helpListScroller.scrollTo(0,0);
                        self.$refs.helpListScroller.resize();
                    }else{
                        self.list = self.list.concat(r.data.list);
                    }
                    self.scrollerParams.totalpage = r.data.totalpage;
                    self.scrollerParams.p++;
                    if (typeof callback == "function") {
                        callback();
                    }
                },res=>{
					if (res.code == 401 || res.code==402) {
						if(window.isApp()){
							rbLink({
								name:'login','query':{ }
							},'replace');
							return false;
						}
						that.loginShow = true
					}else {
						Toast(res.msg)
					}
                });
            },

			loginSuccess(res){
				console.log('-------登录成功--------',res);
				this.loginShow = false;
				location.reload();
			},

			loginCancel(){
				console.log('-------取消登录--------');
				// this.loginShow = false;
			},
            refresh: function (done) {
                let self = this;
                setTimeout(function () {
                    self.scrollerParams.p = 1;
                    self.getData(function(){
                        done();
                    });
                }, 1500)
            },

            infinite: function (done) {
                let self = this;
                if(this.scrollerParams.p > this.scrollerParams.totalpage){
                    done(true);
                    return;
                }
                self.getData(function(){
                    done();
                });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// SaiConfirmManage.vue?431354de